import React from 'react';
import AgencyPackages from './agency/AgencyPackages';

type Props = {
  taraSubscriptionPackages: any[];
};

// Every organisation, seller or agency, is offered only the agency per-seat
// plan.
const SubscriptionPackages = ({ taraSubscriptionPackages }: Props) => {
  return (
    <div>
      <AgencyPackages taraSubscriptionPackages={taraSubscriptionPackages} />
    </div>
  );
};

export default SubscriptionPackages;
